<template>
  <div>
    <a-drawer
      :width="450"
      title="Edit information"
      placement="right"
      :visible="visibleUpdateEmployee"
      @close="() => (visibleUpdateEmployee = false)"
      :bodyStyle="{ overflowY: 'auto', maxHeight: 'calc(100% - 100px)' }"
    >
      <UpdateEmployee
        :updateEmployeeOnView="updateEmployeeOnView"
        :closeDrawerUpdateEmployee="() => (visibleUpdateEmployee = false)"
        :formEmployee="employee"
        :loadingItem="loadingItem"
      />
    </a-drawer>
    <div style="text-align: right;">
      <span
        style="float: left; margin-top: 5px;"
        class="ant-descriptions-title"
      >
        Employee Information
      </span>
      <a-button
        icon="edit"
        type="link"
        @click="() => (visibleUpdateEmployee = true)"
      >
      </a-button>
    </div>
    <a-skeleton :loading="loadingItem" :paragraph="{ rows: 6 }">
      <a-descriptions :column="1">
        <a-descriptions-item label="Code / Mã nhân viên">
          {{ employee.code }}
        </a-descriptions-item>
        <a-descriptions-item label="Fullname / Tên nhân viên">
          {{ employee.fullname }}
        </a-descriptions-item>
        <a-descriptions-item label="Phone / Số điện thoại">
          {{ employee.phone }}
        </a-descriptions-item>
        <a-descriptions-item label="Gender / Giới tính">
          <span v-if="employee.gender === 'NONE'"> Other </span>
          <span v-else-if="employee.gender === 'MALE'"> Male </span>
          <span v-else-if="employee.gender === 'FEMALE'">Female</span>
        </a-descriptions-item>
        <a-descriptions-item label="Birthday / Ngày sinh">
          {{ employee.birthday | formatDate }}
        </a-descriptions-item>
        <a-descriptions-item label="Started Date / Ngày vào công ty">
          {{ employee.startedDate | formatDate }}
        </a-descriptions-item>
        <a-descriptions-item label="Email">
          {{ employee.email }}
        </a-descriptions-item>
        <a-descriptions-item label="Code Department">
          {{ employee.codeDepartment }}
        </a-descriptions-item>
        <a-descriptions-item label="Cost Center">
          {{ employee.costCenter }}
        </a-descriptions-item>
        <a-descriptions-item label="Account / Người dùng">
          {{ employee.user && employee.user.fullname }}
        </a-descriptions-item>
        <a-descriptions-item label="Department / Phòng ban">
          <span
            v-if="
              employee.department && employee.department.status === 'DEACTIVE'
            "
          >
            <del> {{ employee.department.name }} </del>
          </span>
          <span
            v-else-if="
              employee.department && employee.department.status === 'ACTIVE'
            "
          >
            {{ employee.department.name }}
          </span>
        </a-descriptions-item>
        <a-descriptions-item label="Position / Chức vụ">
          <span
            v-if="employee.position && employee.position.status === 'DEACTIVE'"
          >
            <del> {{ employee.position.name }} </del>
          </span>
          <span
            v-else-if="
              employee.position && employee.position.status === 'ACTIVE'
            "
          >
            {{ employee.position.name }}
          </span>
        </a-descriptions-item>
        <a-descriptions-item label="Location / Địa điểm làm việc">
          <span v-if="employee.branchLocation">
            {{ employee.branchLocation.name }}
          </span>
        </a-descriptions-item>
        <a-descriptions-item label="Main Shift / Ca làm việc chính thức">
          <span v-if="employee.workShift">
            {{ employee.workShift.title }}
          </span>
        </a-descriptions-item>
        <!-- <a-descriptions-item label="Người tạo">
          {{ employee.author && employee.author.fullname }}
        </a-descriptions-item>
        <a-descriptions-item label="Ngày tạo">
          {{ employee.createdAt | formatDateHour }}
        </a-descriptions-item>
        <a-descriptions-item label="Cập nhật lần cuối">
          {{ employee.updatedAt | formatDateHour }}
        </a-descriptions-item> -->
      </a-descriptions>
    </a-skeleton>
  </div>
</template>
<script>
import UpdateEmployee from "./updateEmployee";
export default {
  components: { UpdateEmployee },
  props: {
    loadingItem: {
      type: Boolean,
      default: true,
    },
    employee: {
      type: Object,
      default: null,
    },
    updateEmployeeOnView: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      visibleUpdateEmployee: false,
    };
  },
};
</script>
